<div class="modal fade" tabindex="-1" role="dialog" id="custom-exit">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="{{t 'closeModal'}}"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title">{{title}}</h4>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-6">
            {{{body}}}
          </div>
          <div class="col-md-6">
            <img src="{{image_url}}" class="exit-image">
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn" data-dismiss="modal">{{t 'closeModal'}}</button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->